import { inject } from 'vue';

export function useSnackbar() {
    const snackbar = inject('snackbar');

    if (!snackbar) {
        throw new Error(
            'useSnackbar must be used within a component setup function and after the SnackbarService is installed.'
        );
    }

    return snackbar;
}
